export default "__VITE_ASSET__CAZ$hmpD__"